import { createSelector } from '@reduxjs/toolkit'

const loginData = (state) => state.user

export const selectLoginData = createSelector([loginData], (user) => user)
